import { render, staticRenderFns } from "./LayananPublik.vue?vue&type=template&id=c342c902&scoped=true"
import script from "./LayananPublik.vue?vue&type=script&lang=js"
export * from "./LayananPublik.vue?vue&type=script&lang=js"
import style0 from "./LayananPublik.vue?vue&type=style&index=0&id=c342c902&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c342c902",
  null
  
)

export default component.exports